import React from 'react';
import { useBlock } from './SiteContent';

const DEFAULT = { quote: 'Хорошо там, где я есть.' };

export default function Manifest() {
  const m = useBlock('manifest', DEFAULT);
  return (
    <section id="manifest" className="py-14 md:py-20 bg-cream border-y border-ink/10" data-testid="manifest">
      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
        <div className="text-[12px] tracking-[0.24em] uppercase text-wine/70 mb-5 flex items-center justify-center gap-3">
          <span className="gold-divider" />
          <span>мой манифест</span>
          <span className="gold-divider" />
        </div>
        <p className="font-heading italic text-3xl sm:text-4xl md:text-5xl leading-tight text-ink" data-testid="manifest-quote">
          {m.quote}
        </p>
      </div>
    </section>
  );
}
